export default __webpack_public_path__ + "static/media/1008.0226fbe1.svg";